import botImage from '../../../../assets/images/logos/chat.jpg';
export const GuidoBanner = () => {
    return (
        <div className="banner-container">
            <div className="banner-card">
                <div className="image-container">
                    <img src={botImage} alt="Guido" className="guido-image" />
                </div>
            </div>
        </div>
    );
};
